import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_APPLICATION } from '@/modules/apps/router';
import { useAppStore } from '@/modules/apps/store';
import { useAuthStore } from '@/modules/auth/store';
import { applicationService } from '@/services/applications';
import { onBeforeMount } from 'vue';
import { useToast } from 'vue-toastification';
import { useMixins } from './mixins';

export default function () {
    const toast = useToast();
    const router = useAppRouter();
    const authStore = useAuthStore();
    const appStore = useAppStore();

    const { model, v$, currencyOptions } = useMixins();

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () =>
            applicationService.app.create(
                model.name,
                model.currency,
                model.creditInit,
                model.friendLimit,
                model.popupRate,
                model.bindSuggestTime,
                model.remainVipMinutes,
                model.vipTermMinutes,
                model.creditWelcomeLimit,
                model.thumbnailFile
            ),
        onSuccess: async () => {
            await appStore.loadApps();
            router.push({ name: ROUTE_NAME_APPLICATION.INDEX });
        }
    });

    onBeforeMount(() => {
        if (!authStore.isSuperUser) {
            toast.error('Permission denied!');
            router.push({ name: ROUTE_NAME_APPLICATION.INDEX });
        }
    });

    return { model, v$, currencyOptions, create };
}
